import { render, staticRenderFns } from "./AgeGroupForExecutives.vue?vue&type=template&id=a70013c4&scoped=true"
import script from "./AgeGroupForExecutives.vue?vue&type=script&lang=js"
export * from "./AgeGroupForExecutives.vue?vue&type=script&lang=js"
import style0 from "./AgeGroupForExecutives.vue?vue&type=style&index=0&id=a70013c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70013c4",
  null
  
)

export default component.exports